"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _status = require("@/api/iot/status");
var _merchant = require("@/api/merchant");
var _setmeal = require("@/api/iot/setmeal");
var _branch = require("@/api/iot/branch");
var _deviceType = require("@/api/iot/deviceType");
var _device = require("@/api/iot/device");
var _default = {
  props: ['editItem', 'deviceTypeList'],
  data: function data() {
    return {
      dialogVisible: false,
      btnLoading: false,
      form: {
        id: '',
        terminal_no: '',
        contact_name: '',
        contact_mobile: '',
        kwh_price: 0
      },
      rules: {
        kwh_price: [{
          required: true,
          message: '请输入电价',
          trigger: 'change'
        }, {
          type: 'number',
          min: 0,
          message: '电价不能为负数',
          trigger: 'change'
        }]
      },
      merchantList: []
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '电价';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
          }
        });
      } else {
        this.reset();
      }
    }
  },
  mounted: function mounted() {
    // this.getMerchantList()
  },
  methods: {
    // async getMerchantList() {
    //     // console.log('getMerchantList')
    //     let res = await getMerchantList({
    //         status: 1,
    //     })
    //     if (res.data) {
    //         this.merchantList.push(...res.data)
    //     }
    // },
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs['form'].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(valid) {
          var res;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!valid) {
                    _context.next = 9;
                    break;
                  }
                  _this2.btnLoading = true;
                  _context.next = 4;
                  return (0, _device.cabinetSave)(_this2.form).catch(function () {});
                case 4:
                  res = _context.sent;
                  _this2.btnLoading = false;
                  if (res) {
                    _this2.dialogVisible = false;
                    _this2.$emit('getList');
                  }
                  _context.next = 11;
                  break;
                case 9:
                  _this2.$message({
                    message: '请检查表单错误',
                    type: 'error'
                  });
                  return _context.abrupt("return", false);
                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};
exports.default = _default;